// The v2 event response only returns { id, name, playerScored } for each soft score.
// Merge in the full soft score configuration (oncePerEvent, roundByRound, scoreOptions,
// listType, active, scorecardId, etc.) from the v1 event response, matched by id.
export const mergeFullSoftScores = (softScores, fullSoftScores) => {
  if (!Array.isArray(softScores)) return softScores;
  if (!Array.isArray(fullSoftScores) || !fullSoftScores.length)
    return softScores;

  const fullById = {};
  fullSoftScores.forEach((score) => {
    if (score?.id) fullById[score.id] = score;
  });

  return softScores.map((score) =>
    fullById[score?.id] ? { ...score, ...fullById[score.id] } : score
  );
};
